import {ChangeDetectionStrategy, Component, ElementRef, forwardRef, ViewChild} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {AutocompleteInputComponent} from '../autocomplete-input';
import {ShortenWalletAddrPipe} from '../dynamic-xyz/utils/shorten-wallet-addr.pipe';
import {DexWalletAutocompleteDirective} from './dex-wallet-autocomplete/dex-wallet-autocomplete.directive';
import {DexWalletAutocompleteModule} from './dex-wallet-autocomplete/dex-wallet-autocomplete.module';

@Component({
    selector:        'dex-wallet-input',
    templateUrl:     './dex-wallet-input.component.html',
    styleUrl:        '../security-input/security-input.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers:       [
        {
            provide:     NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DexWalletInputComponent),
            multi:       true
        }
    ],
    imports: [
    DexWalletAutocompleteModule,
    ShortenWalletAddrPipe
]
})
export class DexWalletInputComponent extends AutocompleteInputComponent<string> {

    @ViewChild(DexWalletAutocompleteDirective, {static: true})
    public override innerValueAccessor: DexWalletAutocompleteDirective;

    @ViewChild(DexWalletAutocompleteDirective, {read: ElementRef, static: true})
    public override innerInputElementRef: ElementRef;

}
